export default "__VITE_ASSET__BAaENJ5n__"